import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { stringify, parse } from 'query-string';

export function useHistoryFilters(): {
    search: Record<string, any>;
    onSearch: (value: Record<string, any>) => void;
} {
    const navigate = useNavigate();
    const location = useLocation();

    const onSearch = React.useCallback(
        (query: Record<string, any>) => {
            if (query && Object.keys(query)) {
                navigate(`${location.pathname}?${stringify(query)}`, { replace: true });
            } else {
                navigate(location.pathname, { replace: true });
            }
        },
        [location.pathname, navigate]
    );

    const search = React.useMemo(() => parse(location.search), [location.search]);

    return { search, onSearch };
}
